import axios from "../../axios";

const state = {
  list_ec: [],
  list_sm: [],
};

const actions = {
  /**
   * Get list student
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListEC({ commit }) {
    try {
      const response = await axios.get("/get-data/educational-consultants/");
      if (response.status === 200) {
        commit(
          "SET_LIST_EC",
          response.data.filter(function (value) {
            return value.user_id != null;
          }),
        );
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  async getListSM({ commit }) {
    try {
      const response = await axios.get("/user/operations/service-officer");
      if (response.status === 200) {
        commit(
          "SET_LIST_SM",
          response.data.data.filter(function (value) {
            return value.user_id != null;
          }),
        );
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
};

const mutations = {
  SET_LIST_EC(state, data) {
    state.list_ec = data;
  },
  SET_LIST_SM(state, data) {
    state.list_sm = data;
  },
};

const getters = {
  getListECSM(state) {
    return state.list_ec.concat(state.list_sm);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
